module.exports = __webpack_public_path__ + "img/fi.502ae3c8.svg";